import React from 'react';

import Typography from '@mui/material/Typography';

import './styles.scss';

/**
 * A count shown in a table cell that links to the records it counts (e.g. Total Scans -> history).
 * Only a count greater than 0 is a link: there is nothing to open for 0, so it renders as plain text.
 *
 * The click does not bubble, so a row-level click handler (which usually opens the same page) does
 * not fire a second time.
 */
const OlcCountLink = ({ value, onClick, title, className = '' }) => {
  const count = Number(value) || 0;

  if (count <= 0) {
    return (
      <Typography variant="body2" className={className}>
        {count}
      </Typography>
    );
  }

  const handleClick = (event) => {
    event.stopPropagation();
    onClick?.(event);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  return (
    <Typography
      variant="body2"
      className={`olcCountLink ${className}`.trim()}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="link"
      tabIndex={0}
      title={title}
    >
      {count}
    </Typography>
  );
};

export default OlcCountLink;
